/*
 * @Author: Chris 
 * @Date: 2022-07-26 14:52:45 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-11-10 10:17:53
 */

import axios from "axios";
import Vue from "vue";
import router from "@/router/index";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

// 方法1：直接修改Axios实例上defaults属性，主要用来设置通用配置
axios.defaults.headers["Content-type"] = "application/json";

let HUBservice = axios.create({
    baseURL: process.env.VUE_APP_HUB,
    timeout: 50000 // 请求超时时间
});

let service = axios.create({
    baseURL: process.env.VUE_APP_URL,
    timeout: 50000 // 请求超时时间
});

const error = err => {
    if (err.response) {
        switch (err.response.status) {
            case 500:
                break;
            case 403:
                break;
            case 60006:
                break;
            case 401:
                window.localStorage.removeItem("UM_accessToken");
                break;
        }
    }
    return Promise.reject(err);
};

// 请求拦截 可在请求头中加入token等
service.interceptors.request.use(config => {
    NProgress.start() // 设置加载进度条(开始..)
    config.headers["Content-type"] = "application/json";
    if (window.localStorage.getItem("UM_accessToken")) {
        config.headers["accessToken"] = window.localStorage.getItem("UM_accessToken");
    }
    return config;
}, error);

/**
 * HUB的错误返回
 * */

HUBservice.interceptors.response.use(res => {
    NProgress.done() // 设置加载进度条(结束..)
    if (res.data.code == 0 ||
        res.data.code == -1 ||
        res.data.code == 401 ||
        res.data.code == 400 ||
        res.data.code == 500 ||
        res.data.code == 1001 ||
        res.data.code == 3001 ||
        res.data.code == 5001 ||
        res.data.code == 5002 ||
        res.data.code == 5003 ||
        res.data.code == 5004 ||
        res.data.code == 6002 ||
        res.data.code == 6003 ||
        res.data.code == 6004 ||
        res.data.code == 6005 ||
        res.data.code == 6006 ||
        res.data.code == 6007 ||
        res.data.code == 7001 ||
        res.data.code == 7002 ||
        res.data.code == 8004 ||
        res.data.code == 70005 ||
        res.data.code == 6001) {
        Vue.prototype.$notify.error({
            title: '错误',
            message: res.data.msg
        })
        return res;
    } else {
        return res;
    }
}, error);


/**
 * 用户管理系统的接口过滤
 * */

service.interceptors.response.use(res => {
    NProgress.done() // 设置加载进度条(结束..)
    if (res.data.code == 0 ||
        res.data.code == -1 ||
        res.data.code == 400 ||
        res.data.code == 500 ||
        res.data.code == 1001 ||
        res.data.code == 3001 ||
        res.data.code == 5001 ||
        res.data.code == 5002 ||
        res.data.code == 5003 ||
        res.data.code == 6002 ||
        res.data.code == 6003 ||
        res.data.code == 6004 ||
        res.data.code == 6005 ||
        res.data.code == 6006 ||
        res.data.code == 6007 ||
        res.data.code == 7001 ||
        res.data.code == 7002 ||
        res.data.code == 70005 ||
        res.data.code == 500
    ) {
        Vue.prototype.$notify.error({
            title: '错误',
            message: res.data.msg
        })
        return res;
    } else if (res.data.code == 5004 || res.data.code == 401) {

        /**
         * 登录过期
         * */

        window.localStorage.removeItem("UM_accessToken");
        window.localStorage.removeItem("UM_USER_IDENTITY");
        Vue.prototype.$notify.error({
            title: '错误',
            message: res.data.msg
        })

        setTimeout(() => {
            Vue.prototype.$notify.closeAll()
        }, 3500);

        router.push("/login")
        return res;
    } else {
        return res;
    }
}, error);


/**
 * get方法 所以如果有参数 且参数类型为Array 
 * 则转换为"1, 2, 3"的字符串形式
 * */

export function get(url, params) {
    if (params) {
        Object.keys(params).forEach(key => {
            if (Array.isArray(params[key])) {
                params[key] = params[key].toString();
            }
        });
    }
    return new Promise((resolve, reject) => {
        service
            .get(url, {
                params: params
            })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data);
            });
    });
}

export function post(url, params) {
    return new Promise((resolve, reject) => {
        service
            .post(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data);
            });
    });
}

/**
 * 认证中心请求
 * */

export function HUBget(url, params) {
    if (params) {
        Object.keys(params).forEach(key => {
            if (Array.isArray(params[key])) {
                params[key] = params[key].toString();
            }
        });
    }
    return new Promise((resolve, reject) => {
        HUBservice
            .get(url, {
                params: params
            })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data);
            });
    });
}

export function HUBpost(url, params) {
    return new Promise((resolve, reject) => {
        HUBservice
            .post(url, params)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data);
            });
    });
}